import React, { useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import styled from '@emotion/styled';
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { Divider } from '@mui/material';

const muiCache = createCache({
	"key": "mui",
	"prepend": true
});

const Footer=styled('td')(({theme})=>({
    width:'100%',
    background:theme.palette.background.default,
    display:'flex',
    justifyContent:'flex-end',
    gap:'40px',
    borderBottom: `0.5px solid ${theme.palette.third.light}`,
    paddingRight:'10%'
}))
const FooterWrapper=styled('tr')(({theme})=>({
    display:'flex',
    flexDirection:'column',
    justifyContent:'flex-end',
    paddingRight:'20px',
    alignItems:'center'

}))


const StyledMUIDataTable=styled(MUIDataTable)(({theme})=>({
  background:theme.palette.background.default,
  height:'100%',
  marginBottom: '30px',
}))
export default function ExtensionAgreementTable(props) {
  const rate=parseFloat(props?.info?.rate)
  const payment_rate=parseFloat(props?.payment_rate)
  const weeks=parseInt(props?.info?.weeks)
    const columns = [
 {
  name: "c_name",
  label: "Course Name",
  options: {
   filter: false,
   sort: true,
  }
 },
 {
  name: "c_code",
  label: "Course Code",
  options: {
   filter: false,
   sort: true,
   display:false,
  }
 },
 {
   name: "deps",
   label: "Department",
   options: {
     filter: true,
     sort: true,
    }
  },
  {
    name: "section",
    label: "Section",
    options: {
      filter: true,
      sort: true,
    }
  },
  {
  name: "cr_hr",
  label: "Cr.Hr",
  options: {
   filter: false,
   sort: true,
  }
 },
   {
  name: "cr_hr2",
  label: `Cr.Hr*${rate}`,
  options: {
   filter: false,
   sort: true,
  }
 },
   {
  name: "cr_hr3",
  label: `Cr.Hr*${rate}*${weeks}`,
  options: {
   filter: false,
   sort: true,
  }
 },
  {
  name: "pay",
  label: `Amount of Payment`,
  options: {
   filter: false,
   sort: true,
  }
 },
  {
  name: "year",
  label: "Academic Year",
  options: {
   display:false,
   filter: true,
   sort: true,
  filterList: [props.year],
  }
 },
  {
  name: "semester",
  label: "Semester Term",
  options: {
   display:false,
   filter: true,
   sort: true,
  filterList: [props.semester],
  }
 },
]
    const {changed}=useAuth();
    const api=useAxiosPrivate()
    const [data,setData]=useState([])
    useEffect(()=>{
        let isMounted=true;
        const controller=new AbortController();
        const getData=async ()=>{
          try{
            const response=await api.get(`load/viewPart/`,{
              signal:controller.signal
            })
            isMounted &&  setData(response.data)}
          catch(err){
            console.error(err)
          }
        }
        getData();
        return ()=>{
          isMounted=false;
          controller.abort()
        }
          },[changed])
  var leh=0
  const result=data?.map((value)=>{
    leh+=value[4] * rate*weeks*payment_rate
    return([
      value[0],
      value[1],
      value[2],
      value[3],
      value[4],
      value[4] * rate,
      value[4] * rate*weeks,
      value[4] * rate*weeks*payment_rate,
      value[5],
      value[6],

    ])
  })

  const options = {
      filter:false,
      selectableRows:'none',
      rowsPerPage:3,
      rowsPerPageOptions:[3,10,20,40],
      rowHover:false,
      responsive:'vertical',
      pagination:false,
      customFooter:(count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return(<FooterWrapper>
          <Footer>Total <Divider orientation='vertical' flexItem /> {leh}</Footer>
          </FooterWrapper>)} 
 
};
props.setPayment(leh)
 return(
  <CacheProvider value={muiCache}>
  <StyledMUIDataTable
  title={props.title}
  data={result}
  columns={columns}
  options={options}
/></CacheProvider>
 )} 